import React from 'react';
import styles from './Toasts.module.scss';
import {
  Paragraph, H4, TextOnlyUnderlinedButton, If,
} from '../Components';
import AppContext from '../AppContext';
import { getToast } from '../selectors';

export const Toasts = () => (
  <AppContext.Consumer>
    {(context) => {
      const toast = getToast(context);

      if (!toast) return null;
      return (
        <div className={styles.toast}>
          <H4>{toast.title}</H4>
          <Paragraph>{toast.text}</Paragraph>
          <If condition={toast.action}>
            {() => (
              <TextOnlyUnderlinedButton
                text={toast.action.text}
                onClick={toast.action.onClick}
              />
            )}
          </If>
        </div>
      );
    }}
  </AppContext.Consumer>
);

export default Toasts;
